import { commonConstants } from "./commonConstants";

const commonActions = {};

commonActions.getVehiclesMasterData = (id) => ({
  type: commonConstants.VEHICLES_MASTER_SAGA,
  payload: { id },
});

commonActions.getLocationData = (vendor_id) => {
  return {
    type: commonConstants.LOCATION_SAGA,
    vendor_id: vendor_id,
  };
};

commonActions.getManufacturerData = () => ({
  type: commonConstants.VEHICLES_MANUFACTURER_SAGA,
});

commonActions.getAmenitiesData = () => ({
  type: commonConstants.AMENITIES_SAGA,
});

commonActions.uploadAttachment = (formData) => ({
  type: commonConstants.ATTACHMENT_UPLOAD_SAGA,
  formData,
});

commonActions.downloadAttachment = (id) => ({
  type: commonConstants.ATTACHMENT_DOWNLOAD_SAGA,
  id,
});

commonActions.deleteAttachment = (id) => ({
  type: commonConstants.ATTACHMENT_DELETE_SAGA,
  id,
});

commonActions.updateAttachment = (formData) => ({
  type: commonConstants.ATTACHMENT_UPDATE_SAGA,
  formData,
});

commonActions.getNetworkData = () => ({
  type: commonConstants.NETWORK_SAGA,
});

// charger type
commonActions.chargerTypeAction = () => ({
  type: commonConstants.CHARGER_TYPES_SAGA,
});

commonActions.setAmenityAction = () => ({
  type: commonConstants.SET_AMENITIES_SAGA,
});

commonActions.setSnackbarAction = (payload) => ({
  type: commonConstants.SET_SNACKBAR,
  payload: payload,
});

commonActions.getVendorNameData = () => ({
  type: commonConstants.VENDOR_LIST_NAME_SAGA,
});


// commonActions.getOwnerListData = () => ({
//   type: commonConstants.OWNER_LIST_SAGA,
// });
commonActions.getOwnerListData = ({
  from_date,
  to_date,
} = {}) => ({
  type: commonConstants.OWNER_LIST_SAGA,
  payload: {
    from_date: from_date,
    to_date: to_date,
  },
});

// commonActions.getHostListData = () => ({
//   type: commonConstants.HOST_LIST_SAGA,
// });
commonActions.getHostListData = ({
  from_date,
  to_date,
} = {}) => ({
  type: commonConstants.HOST_LIST_SAGA,
  payload: {
    from_date: from_date,
    to_date: to_date,
  },
});

export { commonActions };
